import { MediaFile, MediaType } from "@shared/types/media.types";
import theme from "@shared/utils/themeColors";
import React from "react";

interface MediaPreviewProps {
  files: MediaFile[];
  onRemove: (index: number) => void;
  disabled?: boolean;
}

const MediaPreview: React.FC<MediaPreviewProps> = ({
  files,
  onRemove,
  disabled = false,
}) => {
  if (files.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-2 gap-2 mb-2">
      {files.map((file, index) => (
        <div
          key={index}
          className="relative rounded-md overflow-hidden bg-gray-100 dark:bg-gray-700"
        >
          {file.type === MediaType.IMAGE ? (
            <img
              src={file.uploadedUrl || file.preview}
              alt=""
              className="w-full h-auto object-cover"
            />
          ) : file.type === MediaType.VIDEO ? (
            <video
              src={file.uploadedUrl || file.preview}
              className="w-full h-auto"
              controls
            />
          ) : (
            <div className="flex items-center p-2">
              <svg
                className="h-8 w-8 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>
              <span className="ml-2 text-sm truncate">
                {file.file.name || "File"}
              </span>
            </div>
          )}
          <button
            type="button"
            className="absolute top-1 right-1 bg-gray-800 bg-opacity-60 rounded-full p-1 text-white"
            onClick={() => onRemove(index)}
            disabled={disabled}
          >
            <svg
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          {file.progress < 100 && (
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
              <div
                className={`h-full ${theme.bg.brand}`}
                style={{ width: `${file.progress}%` }}
              ></div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MediaPreview;
